// Function to translate strings from the widget
const dynamicBundle_language = (widget) => {
    widget.data.settings.language.title = theme.strings.rebuyDB_title;
    widget.data.settings.language.total_price_label = theme.strings.rebuyDB_total_price_label;
    widget.data.settings.language.add_to_cart = theme.strings.rebuyDB_add_to_cart;
    widget.data.settings.language.added_to_cart = theme.strings.rebuyDB_added_to_cart;
    widget.data.settings.language.adding_to_cart = theme.strings.rebuyDB_adding_to_cart;
    widget.compileConfig();
};

// Function to apply diferent improvements
function dynamicBundle_fixes() {

    container = document.querySelector(".rebuy-bundle");

    // Positionate and taking control of new dividers
    var divider1 = '<div class="rebuy-bundle__image-divider divider1"><i aria-hidden="true" class="far fa-plus"></i></div>';
    var divider2 = '<div class="rebuy-bundle__image-divider divider2"><i aria-hidden="true" class="far fa-plus"></i></div>';
    var image1 = container.querySelector(".rebuy-bundle__image:nth-child(1)");
    var image2 = container.querySelector(".rebuy-bundle__image:nth-child(2)");
    var image3 = container.querySelector(".rebuy-bundle__image:nth-child(3)");
    var marker1 = '<div class="marker-1"></div>';
    var marker2 = '<div class="marker-2"></div>';
    var marker3 = '<div class="marker-3"></div>';

    image1.insertAdjacentHTML("beforebegin", marker1);
    image2.insertAdjacentHTML("beforebegin", marker2);
    image3.insertAdjacentHTML("beforebegin", marker3);
    container.querySelector(".marker-2").insertAdjacentHTML("beforebegin", divider1);
    container.querySelector(".marker-3").insertAdjacentHTML("beforebegin", divider2);
    
    // Translate product titles from JSON product files
    var productHandle_1 = container.querySelector(".rebuy-product-block:nth-child(1)").getAttribute('class').split(" ")[1];
    var productHandle_2 = container.querySelector(".rebuy-product-block:nth-child(2)").getAttribute('class').split(" ")[1];
    var productHandle_3 = container.querySelector(".rebuy-product-block:nth-child(3)").getAttribute('class').split(" ")[1];

    let productUrl_1 = window.Shopify.routes.root+'products/'+productHandle_1+'.js';
    let productUrl_2 = window.Shopify.routes.root+'products/'+productHandle_2+'.js';
    let productUrl_3 = window.Shopify.routes.root+'products/'+productHandle_3+'.js';

    var productTitle_1 = container.querySelector(".rebuy-product-block:nth-child(1) .rebuy-product-title");
    var productTitle_2 = container.querySelector(".rebuy-product-block:nth-child(2) .rebuy-product-title");
    var productTitle_3 = container.querySelector(".rebuy-product-block:nth-child(3) .rebuy-product-title");

    async function fetchData(){
        try {
            const response1 = await fetch(productUrl_1);
            const response2 = await fetch(productUrl_2);
            const response3 = await fetch(productUrl_3);
            const data1 = await response1.json();
            const data2 = await response2.json();
            const data3 = await response3.json();   

            productTitle_1.innerHTML = data1.title;
            productTitle_2.innerHTML = data2.title;
            productTitle_3.innerHTML = data3.title;

        } catch (error) {
            console.error(error);
        }
    }
    fetchData();

    // Add image placeholders when a product is unticked.
    var input1 = container.querySelector(".rebuy-product-block:nth-child(1) input");
    var input2 = container.querySelector(".rebuy-product-block:nth-child(2) input");
    var input3 = container.querySelector(".rebuy-product-block:nth-child(3) input");   
    var placeholder1 = '<div class="placeholder-1"></div>';
    var placeholder2 = '<div class="placeholder-2"></div>';
    var placeholder3 = '<div class="placeholder-3"></div>';

    input1.addEventListener("click", function() {
        if (this.checked) container.querySelector(".placeholder-1").remove();
        else container.querySelector(".marker-1").insertAdjacentHTML("afterend", placeholder1);
    });
    input2.addEventListener("click", function() {
        if (this.checked) container.querySelector(".placeholder-2").remove();
        else container.querySelector(".marker-2").insertAdjacentHTML("afterend", placeholder2);
    });
    input3.addEventListener("click", function() {
        if (this.checked) container.querySelector(".placeholder-3").remove();
        else container.querySelector(".marker-3").insertAdjacentHTML("afterend", placeholder3);
    });

    // Fired on tick/untick product from the bundle. 
    container.querySelectorAll(".rebuy-product-block input").forEach(function(e) {
        e.addEventListener("click", function() {
            //Fix format total price when it is recalculated
            container.querySelector(".rebuy-bundle__actions-price").classList.add("rebuy-hide-animation");
            container.querySelectorAll(".rebuy-bundle__actions .rebuy-money  span:not(.sr-only)").forEach(function(elem) {
                elem.classList.remove("js-formatted");
            });
            setTimeout(() => { 
                window.formatPrices(".rebuy-bundle__actions .rebuy-money  span:not(.sr-only)");
            }, 10);
            setTimeout(() => { 
                container.querySelector(".rebuy-bundle__actions-price").classList.remove("rebuy-hide-animation");
            }, 50);

            // Show or hide dividers depending of the product ticked/unticked.
            if ((input1.checked && input2.checked && input3.checked) || (input1.checked && !input2.checked && input3.checked)) {
                container.querySelector(".divider1").style.opacity = '1';
                container.querySelector(".divider2").style.opacity = '1';
            }
            else if (input1.checked && input2.checked && !input3.checked) {
                container.querySelector(".divider1").style.opacity = '1';
                container.querySelector(".divider2").style.opacity = '0';
            }
            else if (!input1.checked && input2.checked && input3.checked) {
                container.querySelector(".divider1").style.opacity = '0';
                container.querySelector(".divider2").style.opacity = '1';
            }
            else {
                container.querySelector(".divider1").style.opacity = '0';
                container.querySelector(".divider2").style.opacity = '0';    
            }
        });
    });
}

function showReBuyTitle() {
    const reBuyTitle = document.querySelector('.rebuy-title');
    if (reBuyTitle) reBuyTitle.classList.remove('hidden');
}

document.addEventListener("rebuy.ready", (event) => {
    dynamicBundle_language(event.detail.widget);
    dynamicBundle_fixes();
    showReBuyTitle();
});